var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { push } from 'react-router-redux';
import { CallbackComponent } from 'redux-oidc';
import styled from 'styled-components';
import Constants from '../constants';
var Servicecommunicator = styled.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: none;\n"], ["\n\tdisplay: none;\n"])));
Servicecommunicator.displayName = 'Servicecommunicator';
var CallbackPage = /** @class */ (function (_super) {
    __extends(CallbackPage, _super);
    function CallbackPage(props) {
        var _this = _super.call(this, props) || this;
        _this.processMessage = function (event) {
            if (event.data === 'ClientConfirmed') {
                _this.setState({ clientConfirmed: true });
            }
        };
        _this.getIdentityServerUrl = function () {
            var identityServerUrl = _this.props.userManager.settings.authority;
            if (identityServerUrl && !identityServerUrl.endsWith('/')) {
                identityServerUrl += '/';
            }
            return identityServerUrl;
        };
        _this.state = {
            clientConfirmed: false,
        };
        _this.successCallback = _this.successCallback.bind(_this);
        _this.errorCallback = _this.errorCallback.bind(_this);
        return _this;
    }
    CallbackPage.prototype.componentDidMount = function () {
        window.addEventListener('message', this.processMessage, false);
    };
    CallbackPage.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.processMessage);
    };
    CallbackPage.prototype.successCallback = function (user) {
        var redirectPath = user.state.path;
        var userManagerAppId = this.props.userManager.settings.client_id;
        if (!this.state.clientConfirmed && userManagerAppId && Constants.CONFIRM_CLIENT_APP_IDS.includes(userManagerAppId)) {
            this.props.dispatch(push(Constants.ROUTE_CONFIRM_CLIENT.replace('{ReturnUrl}', redirectPath)));
        }
        else {
            this.props.dispatch(push(redirectPath));
        }
    };
    CallbackPage.prototype.errorCallback = function (error) {
        this.props.dispatch(push('/'));
    };
    CallbackPage.prototype.render = function () {
        var identityServerUrl = this.getIdentityServerUrl();
        return (React.createElement(React.Fragment, null,
            React.createElement(Servicecommunicator, { src: "".concat(identityServerUrl, "home/servicecommunicator"), id: 'servicecommunicator' }),
            React.createElement(CallbackComponent, { userManager: this.props.userManager, successCallback: this.successCallback, errorCallback: this.errorCallback },
                React.createElement("div", { className: 'message' }, "Loading..."))));
    };
    return CallbackPage;
}(React.Component));
export { CallbackPage };
var templateObject_1;
